import { render, staticRenderFns } from "./EditGroup.vue?vue&type=template&id=6046b1cf&scoped=true&"
import script from "./EditGroup.vue?vue&type=script&lang=js&"
export * from "./EditGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6046b1cf",
  null
  
)

export default component.exports